import Image from 'next/image'

import { cn } from '@src/utils/tailwind'

interface Props {
  content: string
  icon: string
  className?: string
}

export function Guarantee({ content, icon, className }: Props) {
  return (
    <div
      className={cn(
        'mt-5 flex w-full items-center justify-center rounded-2xl bg-bodi-gray-pearl p-4 text-body-xs font-semibold text-bodi-black-text lg:text-body-sm',
        className
      )}
    >
      <div className="flex gap-2">
        <Image
          src={icon}
          width={62}
          height={62}
          alt="Money back guarantee badge"
          className="object-contain"
        />
        <div className="flex items-center" dangerouslySetInnerHTML={{ __html: content }}></div>
      </div>
    </div>
  )
}
